var _g, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 46,
    viewBox: "0 0 31 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12940_13236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 30.3941C6 30.9876 6.26365 31.5505 6.71963 31.9305L13.9226 37.933C14.6643 38.5511 15.7417 38.5511 16.4834 37.933L23.6864 31.9305C24.1424 31.5505 24.406 30.9876 24.406 30.3941V7C24.406 5.89543 23.5106 5 22.406 5H8C6.89543 5 6 5.89543 6 7V30.3941Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2432 37.5488C14.7994 38.0122 15.6069 38.0123 16.1631 37.5488L23.3662 31.5469C23.7081 31.262 23.9061 30.8395 23.9062 30.3945V7C23.9062 6.17165 23.2346 5.50013 22.4062 5.5H8C7.17157 5.5 6.5 6.17157 6.5 7V30.3945C6.50013 30.8395 6.69817 31.262 7.04004 31.5469L14.2432 37.5488Z",
    stroke: "#F4F4F4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.78947,
    height: 14.3158,
    transform: "matrix(1 0 0 -1 10.4727 26.4736)",
    fill: "#C2C2C2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.78947,
    height: 14.3158,
    transform: "matrix(1 0 0 -1 18.5273 26.4736)",
    fill: "#C2C2C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12940_13236",
    x: 0,
    y: 0,
    width: 30.4062,
    height: 45.3965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12940_13236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12940_13236",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetericon);
export default __webpack_public_path__ + "static/media/metericon.64af0f7075ecd30b3711226313506149.svg";
export { ForwardRef as ReactComponent };